import { ApiProperty } from "@nestjs/swagger";


export class UnitDayHourMinuteRequest {
    @ApiProperty()
    unit: string;
    @ApiProperty()
    date: string;
    @ApiProperty()
    hour: number;
    @ApiProperty()
    fromMinute: string;
    @ApiProperty()
    toMinute: string;
    
    ntd?: boolean;
}